import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { DATA_TYPE, DATA_TYPE_LIST, TIME_TYPE_OBJ, } from "@/common/common-list-enum";
import piDatePicke from "@/components/pi-date-picke/pi-date-picke.vue";
import statisticsEcharts from "@/components/pi-statistics-echarts/pi-statistics-echarts.vue";
import i18n from "@/config/i18n";
import { getMchStatisticsOrder, getMchChartElec, } from "@/api/api-operation-service";
import { piThThisTimes } from "@/utils/time.helper";
const ORDER_TYPE = {
    chargeOrder: 1,
    reservationOrder: 2,
    offlineOrder: 3,
};
let PiOperDataRevenueData = class PiOperDataRevenueData extends Vue {
    constructor() {
        super(...arguments);
        this.time = [];
        this.dateTypeList = DATA_TYPE_LIST;
        this.timeTypeObj = TIME_TYPE_OBJ;
        this.formInline = {
            dateType: DATA_TYPE.month,
            beginTime: "",
            endTime: "",
        };
        this.orderData = {};
        this.btnList = [
            {
                name: i18n.t("operationData.chargeOrderCount"),
                value: 0,
                type: ORDER_TYPE.chargeOrder,
                key: "chargeOrderCount",
            },
            {
                name: i18n.t("operationData.reservationOrderCount"),
                value: 0,
                type: ORDER_TYPE.reservationOrder,
                key: "reservationOrderCount",
            },
            {
                name: i18n.t("operationData.offlineOrderCount"),
                value: 0,
                type: ORDER_TYPE.offlineOrder,
                key: "offlineOrderCount",
            },
        ];
        this.orderType = ORDER_TYPE.chargeOrder;
        this.win = window;
        this.configData = {
            type: "line",
        };
        this.option = {
            color: [
                "#014A98",
            ],
            grid: {
            // left: 30,
            },
            yAxis: {
                axisLabel: {
                    margin: -20,
                },
            },
            series: [
                {
                    name: "",
                    data: [],
                    areaStyle: {
                        opacity: 0.8,
                        color: new this.win.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: "rgba(1,74,152,0.1)",
                            },
                            {
                                offset: 1,
                                color: "rgba(1,74,152,0)",
                            },
                        ]),
                    },
                },
            ],
        };
    }
    /**
     * 时间选择
     */
    timeChange(val) {
        this.formInline.beginTime = val[0];
        this.formInline.endTime = val[1];
        this.init();
    }
    /**
     * 类型选择
     */
    radioClick(val) {
        this.orderType = val;
        this.getMchChartElec();
    }
    /**
     * 获取数据
     */
    async getData() {
        const ret = await getMchStatisticsOrder(this.formInline);
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            this.orderData = data;
        }
    }
    /**
     * 获取图表数据
     */
    async getMchChartElec() {
        const ret = await getMchChartElec({
            ...this.formInline,
            orderType: this.orderType,
        });
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            let nameArr = this.btnList.filter((item) => {
                return item.type == this.orderType;
            });
            let option = { ...this.option };
            option.series[0].data = data;
            option.series[0].name = nameArr[0] ? nameArr[0].name : "";
            this.option = option;
        }
    }
    init() {
        this.getData();
        this.getMchChartElec();
    }
    mounted() {
        let startTime = piThThisTimes("yyyy") + "-01";
        let endTime = piThThisTimes("yyyy-MM");
        this.time = [startTime, endTime];
        this.formInline.beginTime = startTime;
        this.formInline.endTime = endTime;
        this.init();
    }
};
PiOperDataRevenueData = __decorate([
    Component({
        components: {
            "pi-date-picke": piDatePicke,
            "pi-statistics-echarts": statisticsEcharts,
        },
    })
], PiOperDataRevenueData);
export default PiOperDataRevenueData;
